import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // Added Router import
import { DavinciLoadWidgetService, DaVinciSuccessResponse } from '../davinci-services/davinci-load-widget.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { jwtDecode } from 'jwt-decode';

interface MyTokenPayload {
  username: string;
  exp: number;
  iat: number;
  [key: string]: any;
}

@Component({
  selector: 'app-davinci-manage-account',
  templateUrl: './davinci-manage-account.component.html',
  styleUrls: ['./davinci-manage-account.component.scss']
})
export class DavinciManageAccountComponent implements OnInit, OnDestroy {
  @ViewChild('davinciContainer', { static: true })
  davinciContainer!: ElementRef<HTMLElement>;
  private routeParamsSub: Subscription | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router, // Injected Router here
    private davinciService: DavinciLoadWidgetService
  ) { }

  ngOnInit() {
    this.routeParamsSub = this.activatedRoute.params.subscribe(params => {
      // Extract section from route parameter for deep-linking
      const { section } = params;

      const token = localStorage.getItem('ping-access-token');

      if (!token) {
        console.error('No access token found in localStorage');
        this.davinciContainer.nativeElement.innerText = 'Access token not found.';
        return;
      }

      let decoded: MyTokenPayload;
      try {
        decoded = jwtDecode<MyTokenPayload>(token);
        console.log('Decoded Token:', decoded);
      } catch (error) {
        console.error('Invalid JWT token:', error);
        this.davinciContainer.nativeElement.innerText = 'Invalid token.';
        return;
      }

      if (!section) {
        this.davinciContainer.nativeElement.innerText = 'Error: Required section information is missing.';
        return;
      }

      const flowInputData = {
        deepLinkReference: section,
        username: decoded.username,
        accessToken: token
      };

      this.davinciService.renderFlow({
        policyId: environment.ping_manage_account_flow_policyId,
        targetElement: this.davinciContainer.nativeElement,
        flowInputData,
        onReady: () => {
          console.log('DaVinci widget is ready to render.');
        }
      }).subscribe({
        next: (response: DaVinciSuccessResponse) => {
          console.log('Manage account flow completed successfully!', response);
          if (
            response.additionalProperties &&
            response.additionalProperties.action === 'logout'
          ) {
            const logoutUri = encodeURIComponent(environment.sso_issuers[0].logout_uri);
            window.location.assign(`${window.location.origin}/logout?logout_uri=${logoutUri}`);
          }
          // Handle successful flow completion here
        },
        error: (err) => {
          console.error('An error occurred during the DaVinci manage account flow:', err);
          this.router.navigate(['/error']); // Now works because this.router is defined
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.routeParamsSub) {
      this.routeParamsSub.unsubscribe();
    }
  }
}
